import { RESET_STATE } from 'store/global/actions';

import { SCHEMA_ACTION_TYPE } from '../actions';

const initialState = {};

const schemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SCHEMA_ACTION_TYPE.SET_MARGIN_SCHEMA:
      return payload || initialState;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default schemaReducer;
